import DashboardHeader from "../DashboardHeader/DashboardHeader";
import React, { useState, useEffect, useRef } from "react";
import TokenSuccessfulComponent from "../TokenSuccessfulComponent/TokenSuccessfulComponent";
import PurchaseHistory from "../PurchaseHistory/PurchaseHistory";
import AddNewCard from "../AddNewCard/AddNewCard";
import Notification from "../Dashboard/Notification/Notification";
import { useLocation } from "react-router-dom";

const TokenPaymentSuccessfulPage = () => {
  const [activeTab, setActiveTab] = useState("buyTokens");
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const notificationRef = useRef(null)
  const location = useLocation()

  const params = new URLSearchParams(location.search)
	const clientId = params.get("clientId")

    
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setIsNotificationOpen(false);
      }
    };
          
    if (isNotificationOpen) {
      document.addEventListener('mousedown', handleOutsideClick);
    }
          
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [isNotificationOpen]);
      
        
    const handleNotificationOpen = () => {
      setIsNotificationOpen(true);
    }
    const handleNotificationClose = () => {
      setIsNotificationOpen(false);
    };
    
    const handleTabClick = (tab) => {
        setActiveTab(tab);
      };
  
  return (
    <div className="payment-platform">
      <DashboardHeader heading='Tokens' handleNotificationOpen={handleNotificationOpen} />
      <Notification ref={notificationRef} handleNotificationClose={handleNotificationClose} isNotificationOpen={isNotificationOpen} />
      <div className="payment-success-container">

      <div className="payment-navigation">
        <div className={` ${
          activeTab === "buyTokens" ? "payment-nav-active" : "payment-nav-inactive"
        }`}
        onClick={() => handleTabClick("buyTokens")}>Buy Tokens</div>
        <div className={`${
          activeTab === "purchaseHistory" ? "payment-nav-active" : "payment-nav-inactive"
        }`}
        onClick={() => handleTabClick("purchaseHistory")}>Purchase History</div>
        <div className={`${
          activeTab === "paymentMethod" ? "payment-nav-active" : "payment-nav-inactive"
        }`}
        onClick={() => handleTabClick("paymentMethod")}>Payment Method</div>
      </div>
        {activeTab === "buyTokens" && <TokenSuccessfulComponent clientId={clientId} />}
        {activeTab === "purchaseHistory" && <PurchaseHistory />}
        {activeTab === "paymentMethod" && <AddNewCard />}
      </div>
    </div>
  );
};

export default TokenPaymentSuccessfulPage;